import { BaseLog, BaseLogArgs } from './BaseLog';
import { LEVEL } from './LEVEL';

export function AssetsLoadErrorLog({ message, data, stacktrace }: Partial<BaseLogArgs>) {
    return BaseLog({
        category: 'ASSETS_LOAD_ERROR',
        message,
        data,
        stacktrace,
        level: LEVEL.WARN
    });
}
